// extracted by mini-css-extract-plugin
export var textInput = "_jh-0";